// // import { Card, Col, Row, Typography, Tag, Button, Dropdown, Menu } from 'antd';
// // import { DownOutlined } from '@ant-design/icons';

// // const { Title, Text } = Typography;

// // const dataBlock = [
// //   {
// //     title: 'Summary',
// //     values: ['kVA T', 'kW T', 'I Avg', 'V LL Avg'],
// //   },
// //   {
// //     title: 'Apparent Power',
// //     values: ['kVA r', 'kVA y', 'kVA b', 'kVA T'],
// //   },
// //   {
// //     title: 'Real Power',
// //     values: ['kW r', 'kW y', 'kW b', 'kW T'],
// //   },
// //   {
// //     title: 'Reactive Power',
// //     values: ['kVAr r', 'kVAr y', 'kVAr b', 'kVAr T'],
// //   },
// //   {
// //     title: 'Energies',
// //     values: ['kWh Imp', 'kWh Exp', 'kVAh Imp', 'kVAh Exp'],
// //   },
// //   {
// //     title: 'PF',
// //     values: ['PF r', 'PF y', 'PF b', 'PF T'],
// //   },
// //   {
// //     title: 'Voltage',
// //     values: ['V LL r', 'V LL y', 'V LL b', 'V LL Avg'],
// //   },
// //   {
// //     title: 'Current',
// //     values: ['I r', 'I y', 'I b', 'I Avg'],
// //   },
// // ];

// // const MeterStatusView = () => {
// //   const renderBlock = (title, values) => (
// //     <Card size="small" title={title} bordered={false} style={{ marginBottom: 16 }}>
// //       <Row gutter={[8, 8]}>
// //         {values.map((item, index) => (
// //           <Col span={12} key={index}>
// //             <div style={{ background: index === values.length - 1 ? '#f6ffed' : '#e6f7ff', padding: 8, borderRadius: 4 }}>
// //               <Text strong>{item}</Text>: <Text>46,250.00</Text>
// //             </div>
// //           </Col>
// //         ))}
// //       </Row>
// //     </Card>
// //   );

// //   const menu = (
// //     <Menu>
// //       <Menu.Item key="1">Download as PDF</Menu.Item>
// //       <Menu.Item key="2">Export as CSV</Menu.Item>
// //     </Menu>
// //   );

// //   return (
// //     <div style={{ padding: 24, background: '#fff', minHeight: '100vh' }}>
// //           <Title level={4}>EB IN</Title>
// //       <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
// //         <div className='flex items-start justify-start'>
// //           <Text>Meter ID: <strong>MT-2024-0231</strong></Text><br />
// //           <Text>Last Poll: <strong>2024-02-20 15:30:22</strong></Text>
// //           <Tag color="green" style={{ marginLeft: 8 }}>Working</Tag>
// //         </div>
// //         <Dropdown overlay={menu}>
// //           <Button>
// //             Download <DownOutlined />
// //           </Button>
// //         </Dropdown>
// //       </div>

// //       <Row gutter={[16, 16]}>
// //         {dataBlock.map((block, idx) => (
// //           <Col span={6} key={idx}>
// //             {renderBlock(block.title, block.values)}
// //           </Col>
// //         ))}
// //       </Row>
// //     </div>
// //   );
// // };

// // export default MeterStatusView;



// import React, { useRef } from 'react';
// import { Card, Col, Row, Typography, Tag, Dropdown, Button, Menu } from 'antd';
// import { DownOutlined } from '@ant-design/icons';
// import { useSelector } from 'react-redux';
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
// import { data } from 'autoprefixer';

// const { Title, Text } = Typography;

// const sections = [
//   {
//     title: 'Summary',
//     data: ['kVA T', 'kW T', 'I Avg', 'V LL Avg'],
//   },
//   {
//     title: 'Apparent Power',
//     data: ['kVA r', 'kVA y', 'kVA b', 'kVA T'],
//   },
//   {
//     title: 'Real Power',
//     data: ['kW r', 'kW y', 'kW b', 'kW T'],
//   },
//   {
//     title: 'Reactive Power',
//     data: ['kVAr r', 'kVAr y', 'kVAr b', 'kVAr T'],
//   },
//   {
//     title: 'Energies',
//     data: ['kWh Imp', 'kWh Exp', 'kVAh Imp', 'kVAh Exp'],
//   },
//   {
//     title: 'PF',
//     data: ['PF r', 'PF y', 'PF b', 'PF T'],
//   },
//   {
//     title: 'Voltage',
//     data: ['V LL r', 'V LL y', 'V LL b', 'V LL Avg'],
//   },
//   {
//     title: 'Current',
//     data: ['I r', 'I y', 'I b', 'I Avg'],
//   },
// ];

// const getCellColor = (index, length) =>
//   index === length - 1 ? '#f6ffed' : '#e6f7ff';


// // const menu = (
// //   <Menu>
// //     <Menu.Item key="1">Download as PDF</Menu.Item>
// //     <Menu.Item key="2">Export as CSV</Menu.Item>
// //   </Menu>
// // );

// const EBMeterDashboard = ({parameters}) => {
//  const componentRef = useRef(null);
//      const mode = useSelector((state) => state.darkMode);
//       const color = useSelector((state) => state.ThemeChange);
//       console.log(color);
//       const { isdarkMode } = mode
//       console.log(isdarkMode)
//       console.log(parameters)
//   const handleDownload = async (type) => {
//     const element = componentRef.current;
//     return;
//     console.log(element)
//     if (!element) return;

//     try {
//       const canvas = await html2canvas(element, { scale: 2 });
//       const dataURL = canvas.toDataURL("image/png");

//       if (type === "png") {
//         const link = document.createElement("a");
//         link.href = dataURL;
//         link.download = "component.png";
//         link.click();
//       }

//       if (type === "pdf") {
//         const pdf = new jsPDF("p", "mm", "a4");
//         const imgProps = pdf.getImageProperties(dataURL);
//         const pdfWidth = pdf.internal.pageSize.getWidth();
//         const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

//         pdf.addImage(dataURL, "PNG", 0, 0, pdfWidth, pdfHeight);
//         pdf.save("component.pdf");
//       }
//     } catch (error) {
//       console.error("Download error:", error);
//     }
//   };

//   const menu = (
//     <Menu onClick={({ key }) => handleDownload(key)}>
//       <Menu.Item key="png">Download as PNG</Menu.Item>
//       <Menu.Item key="pdf">Download as PDF</Menu.Item>
//     </Menu>
//   );
//   return (
//     <div style={{ }} 
//     ref={componentRef}
//     className={` ${isdarkMode ? 'bg-transparent' : ''}`}>
//       {/* Header */}
//       <div style={{
//         display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24
//       }}> 
//         <div className='-mt-5'>
//           <Title level={4}>{parameters.metername}</Title>
//           <Text>Meter ID: <strong>{parameters.meterid}</strong></Text><br />
//           <Text>Last Poll: <strong>2024-02-20 15:30:22</strong></Text>
//           <Tag color="green" style={{ marginLeft: 8 }}>Working</Tag>
//         </div>
//         <Dropdown overlay={menu}>
//           <Button>
//             Download <DownOutlined />
//           </Button>
//         </Dropdown>
//       </div>

//       {/* Cards Grid */}
//       <Row gutter={[16, 16]} >
//         {sections.map((section, idx) => (
//           <Col xs={24} sm={12} md={12} lg={6} key={idx}>
//             <Card title={section.title} size="small" bordered={false}>
//               {section.data.map((item, i) => (
//                 <div
//                   key={i}
//                   style={{
//                     backgroundColor: getCellColor(i, section.data.length),
//                     padding: '8px 12px',
//                     marginBottom: 8,
//                     borderRadius: 4,
//                   }}
//                   className='flex items-center justify-between'
//                 >
//                   <Text strong>{item}</Text>
//                   <div><Text>46,250.00</Text></div>
//                 </div>
//               ))}
//             </Card>
//           </Col>
//         ))}
//       </Row>
//     </div>
//   );
// };

// export default EBMeterDashboard;

 
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { Button, Dropdown, Menu, Typography, Tag, Row, Col, Card } from "antd";
import { DownOutlined } from "@ant-design/icons";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const { Title, Text } = Typography;

const getCellColor = (index, total) => {
  const intensity = 255 - Math.floor((index / total) * 100);
  return `rgb(${intensity}, ${intensity}, ${intensity})`;
};

const EBMeterDashboard = ({ parameters }) => {
  const componentRef = useRef(null);
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;

  const handleDownload = async (type) => {
    const element = componentRef.current;
    if (!element) return;

    try {
      const canvas = await html2canvas(element, { scale: 2 });
      const dataURL = canvas.toDataURL("image/png");

      if (type === "png") {
        const link = document.createElement("a");
        link.href = dataURL;
        link.download = "component.png";
        link.click();
      }

      if (type === "pdf") {
        const pdf = new jsPDF("p", "mm", "a4");
        const imgProps = pdf.getImageProperties(dataURL);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        pdf.addImage(dataURL, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save("component.pdf");
      }
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  const menu = (
    <Menu onClick={({ key }) => handleDownload(key)}>
      <Menu.Item key="png">Download as PNG</Menu.Item>
      <Menu.Item key="pdf">Download as PDF</Menu.Item>
    </Menu>
  );


  // Dynamic section definitions from parameters
  const sections = [
    {
      title: "Summary",
      data: [
        `kVA T: ${parameters.kvat}`,
        `kW T: ${parameters.kwt}`,
        `I Avg: ${parameters.iavg}`,
        `V LL Avg: ${parameters.vllAvg}`,
      ],
    },
    {
      title: "Apparent Power",
      data: [
        `KVA r: ${parameters.kvA_R}`,
        `KVA y: ${parameters.kvA_Y}`,
        `KVA b: ${parameters.kvA_B}`,
        `KVA T: ${parameters.kvat}`,
      ],
    },
    {
      title: "Real Power",
      data: [
        `kW r: ${parameters.kwr}`,
        `kW y: ${parameters.kwy}`,
        `kW b: ${parameters.kwb}`,
        `kW T: ${parameters.kwt}`,
      ],
    },
    {
      title: "Reactive Power",
      data: [
        `kVA r: ${parameters.kvA_R}`,
        `kVA y: ${parameters.kvA_Y}`,
        `kVA b: ${parameters.kvA_B}`,
        `kVAR T: ${parameters.kvart}`,
      ],
    },
    {
      title: "PF",
      data: [
        `PF r: ${parameters.pfr}`,
        `PF y: ${parameters.pfy}`,
        `PF b: ${parameters.pfb}`,
        `PF T: ${parameters.pft}`,
      ],
    },
    {
      title: "Energies",
      data: [
        `kWh Imp: ${parameters.kWhImport}`,
        `kWh Exp: ${parameters.kwhexport}`,
        `kVAh Imp: ${parameters.kVAh}`,
        `kVAh Exp: ${parameters.kVArhTotal}`,
      ],
    },
    {
      title: "Voltage",
      data: [
        `V LL r: ${parameters.f}`,
        `V LL y: ${parameters.kwd}`,
        `V LL b: ${parameters.kvad}`,
        `V LL Avg: ${parameters.powersupplyInteruption}`,
      ],
    },
    {
      title: "Current",
      data: [
        `I r: ${parameters.ir}`,
        `I y: ${parameters.iy}`,
        `I b: ${parameters.ib}`,
        `I Avg: ${parameters.iavg}`,
      ],
    },
    
  ];

  console.log(parameters)

  return ( 
    <div
      ref={componentRef}
      className={`${isdarkMode ? "bg-transparent" : ""}`}
    >
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <div className="-mt-5">
          <Title level={4}>{parameters.metername}</Title>
          <Text>Meter ID: <strong>{parameters.meterid}</strong></Text><br />
          <Text>Last Poll: <strong>{parameters.createdon.replace("T"," ")}</strong></Text>
          <Tag color={`${parameters.meterStatus=='ON'?"green":"red"}`} style={{ marginLeft: 8 }}>{parameters.meterStatus=='idle'?'Idle':parameters.meterStatus=='ON'?'Working':'OFF'}</Tag>
        </div>
        <Dropdown overlay={menu}>
          <Button>
            Download <DownOutlined />
          </Button>
        </Dropdown>
      </div>

      {/* Cards Grid */}
      <Row gutter={[16, 16]}>
        {sections.map((section, idx) => (
          <Col xs={24} sm={12} md={12} lg={6} key={idx}>
            <Card title={section.title} size="small" bordered={false}>
              {section.data.map((item, i) => (
                <div
                  key={i}
                  style={{
                    backgroundColor: getCellColor(i+1, section.data.length),
                    padding: "8px 12px",
                    marginBottom: 8,
                    borderRadius: 4,
                  }}
                  className="flex items-center justify-between"
                >
                  <Text>{item}</Text>
                </div>
              ))}
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default EBMeterDashboard;
